import styled from '@emotion/styled'
import { ITheme } from 'application/utils/type'

interface ISeparatorProps {
  theme: ITheme 
}

export const Separator = styled('div')<ISeparatorProps>`
  label: Separator;
  width: 100%;
  height: 1px;
  background: ${(props) => props.theme.colors.borderColor};
`
